/// <reference types="@angular/localize" />

import 'zone.js';
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {environment} from "@environments/environment";
import {enableProdMode} from "@angular/core";
import {AppModule} from "@app/app.module";

if (environment.production) {
   enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
